/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WorkbookItemType } from './WorkbookItemType';
import {
    WorkbookItemTypeFromJSON,
    WorkbookItemTypeFromJSONTyped,
    WorkbookItemTypeToJSON,
    WorkbookItemTypeToJSONTyped,
} from './WorkbookItemType';
import type { Workbook } from './Workbook';
import {
    WorkbookFromJSON,
    WorkbookFromJSONTyped,
    WorkbookToJSON,
    WorkbookToJSONTyped,
} from './Workbook';

/**
 * 
 * @export
 * @interface WorkbookItem
 */
export interface WorkbookItem {
    /**
     * 
     * @type {string}
     * @memberof WorkbookItem
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WorkbookItem
     */
    isActive?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof WorkbookItem
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof WorkbookItem
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof WorkbookItem
     */
    workbookId?: string;
    /**
     * 
     * @type {Workbook}
     * @memberof WorkbookItem
     */
    workbook?: Workbook;
    /**
     * 
     * @type {string}
     * @memberof WorkbookItem
     */
    title?: string | null;
    /**
     * 
     * @type {WorkbookItemType}
     * @memberof WorkbookItem
     */
    itemType?: WorkbookItemType;
    /**
     * 
     * @type {number}
     * @memberof WorkbookItem
     */
    sortOrder?: number;
    /**
     * 
     * @type {boolean}
     * @memberof WorkbookItem
     */
    isLocked?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WorkbookItem
     */
    version?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkbookItem
     */
    stateJson?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkbookItem
     */
    snapshotJson?: string | null;
}



/**
 * Check if a given object implements the WorkbookItem interface.
 */
export function instanceOfWorkbookItem(value: object): value is WorkbookItem {
    return true;
}

export function WorkbookItemFromJSON(json: any): WorkbookItem {
    return WorkbookItemFromJSONTyped(json, false);
}

export function WorkbookItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkbookItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'workbookId': json['workbookId'] == null ? undefined : json['workbookId'],
        'workbook': json['workbook'] == null ? undefined : WorkbookFromJSON(json['workbook']),
        'title': json['title'] == null ? undefined : json['title'],
        'itemType': json['itemType'] == null ? undefined : WorkbookItemTypeFromJSON(json['itemType']),
        'sortOrder': json['sortOrder'] == null ? undefined : json['sortOrder'],
        'isLocked': json['isLocked'] == null ? undefined : json['isLocked'],
        'version': json['version'] == null ? undefined : json['version'],
        'stateJson': json['stateJson'] == null ? undefined : json['stateJson'],
        'snapshotJson': json['snapshotJson'] == null ? undefined : json['snapshotJson'],
    };
}

export function WorkbookItemToJSON(json: any): WorkbookItem {
    return WorkbookItemToJSONTyped(json, false);
}

export function WorkbookItemToJSONTyped(value?: WorkbookItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'isActive': value['isActive'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
        'workbookId': value['workbookId'],
        'workbook': WorkbookToJSON(value['workbook']),
        'title': value['title'],
        'itemType': WorkbookItemTypeToJSON(value['itemType']),
        'sortOrder': value['sortOrder'],
        'isLocked': value['isLocked'],
        'version': value['version'],
        'stateJson': value['stateJson'],
        'snapshotJson': value['snapshotJson'],
    };
}

